import * as React from 'react';

function Svg12Copy( props ){
  return (
    <svg
      width={ 12 }
      height={ 12 }
      { ...props }
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M7.17 2.277v.425h1.702c.238 0 .426.188.426.426v1.276h.425V3.128a.854.854 0 0 0-.85-.851zM1.851 2.277a.854.854 0 0 0-.851.85v7.022c0 .467.384.851.851.851h2.553v-.426H1.851a.422.422 0 0 1-.425-.425V3.128c0-.238.188-.426.425-.426h1.702v-.425Z'
        color='#000'
        fill='#000'
        strokeWidth={ 0 }
        strokeDasharray='none'
      />
      <path
        d='M3.57 1a.537.537 0 0 0-.504.7l.426 1.277a.533.533 0 0 0 .504.363h2.731a.533.533 0 0 0 .505-.363l.425-1.276A.537.537 0 0 0 7.153 1H3.57Zm0 .426h3.583c.08 0 .126.064.101.14L6.83 2.843a.105.105 0 0 1-.102.072h-2.73a.105.105 0 0 1-.102-.072l-.426-1.277c-.025-.076.022-.14.1-.14ZM6.32 5.468a.854.854 0 0 0-.852.851v3.83c0 .468.383.851.851.851h3.83a.854.854 0 0 0 .851-.851v-3.83a.854.854 0 0 0-.851-.85Zm0 .426h3.829a.42.42 0 0 1 .425.425v3.83a.42.42 0 0 1-.425.425h-3.83a.42.42 0 0 1-.425-.425v-3.83a.42.42 0 0 1 .425-.425z'
        color='#000'
        fill='#000'
        strokeWidth={ 0 }
        strokeDasharray='none'
      />
      <path
        d='M6.957 6.745v.425h2.554v-.425ZM6.957 8.021v.426h2.554V8.02ZM6.957 9.298v.425h.958v-.425Z'
        color='#000'
        fill='#000'
        strokeWidth={ 0 }
        strokeDasharray='none'
      />
    </svg>
  );
}

export default Svg12Copy;
